export default {
  props: {
    isMyMessage: { type: Boolean, default: false },
    message: { type: Object, required: true },
  },
}
